export const CSRF_PARAM =
  typeof document !== "undefined"
    ? document.querySelector('meta[name="csrf-param"]')?.getAttribute("content")
    : null;

export const CSRF_TOKEN =
  typeof document !== "undefined"
    ? document.querySelector('meta[name="csrf-token"]')?.getAttribute("content")
    : null;
